import { OverlayProvider } from "@vfuk/core-overlay-controller";
import Paragraph from "@vfuk/core-paragraph";
import { useState, useEffect } from "react";
import Button from "@vfuk/core-button";
import { useTranslation } from "react-i18next";
import { setCookie, getCookie } from "@vfuk/core-helpers";
import Link from "@vfuk/core-link";
import { Modal } from "@ucchub/ui";
import baseEnv from "../../environments/development";
import { CookiesStyles } from "./CookiesStyles";

const CookiesPopup = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (getCookie("acceptCookies") !== "true") {
      setIsOpen(true);
    }
  }, []);

  const acceptCookies = () => {
    setIsOpen(false);
    setCookie("acceptCookies", "true");
  };

  const cookiesBody = t("core:cookies.body").split("[LINK]");
  const linkText = t("core:cookies.link");
  return (
    <OverlayProvider>
      <Modal
        srName="cookies-popup"
        isOpen={isOpen}
        isClosable={false}
        size={4}
        animate
      >
        <CookiesStyles>
          <h4>{t("core:cookies.header")}</h4>
          <Paragraph>
            {cookiesBody[0]}
            <b>
              <Link
                href={baseEnv.privacyPolicyLink}
                text={linkText}
                showUnderline={true}
                size={2}
              />
            </b>
            {cookiesBody[1]}
          </Paragraph>
          <Button
            text={t("core:cookies.acceptCookies")}
            onClick={acceptCookies}
          />
        </CookiesStyles>
      </Modal>
    </OverlayProvider>
  );
};
export default CookiesPopup;
